import React, {useRef} from 'react';
import Datepicker from 'react-datepicker';
import Col from 'react-bootstrap/Col';
import {parse} from 'date-fns';
import { LabelText } from '../../Language/LabelText';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './index.css';

export default function CalendarFooter(props) {
    const fromRef= useRef(null);
    const untilRef= useRef(null);
   
    const calendarTooltip = (
        <Tooltip id="calendarIcon">
            <LabelText tid="calendar" />
        </Tooltip>
    )

    const fromCalendarOpenHandler = (ev) => {
        fromRef.current.setOpen(true);
        fromRef.current.setFocus(true);
    }

    
    const untilCalendarOpenHandler = (ev) => {
        untilRef.current.setOpen(true);
        untilRef.current.setFocus(true);
    }

    return (         
            <Col className="Overview-footer-col">      
                <div className="dateLabel">
                    <span><LabelText tid="SetDateRange" /></span>
                </div>            
                <div className="dateFromLabel">
                    <LabelText tid="From" />
                </div>
                <div className="datePickerFromWidth">
                    <Datepicker
                        className={!props.isInValidFromDate ? undefined : "highlight-date-field"}
                        tabIndex="0"
                        title="From date calendar"
                        ref={fromRef}
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={props.fromDate}
                        minDate={props.fromMinDate && parse(props.fromMinDate, "dd/MM/yyyy", new Date())}
                        maxDate={props.fromMaxDate && parse(props.fromMaxDate, "dd/MM/yyyy", new Date())}
                        onChange={date => props.fromDateChangeHandler(date)} 
                        strictParsing={true} 
                        popperPlacement="right-end"
                        popperModifiers={{
                            offset: {
                                enabled: true,
                                offset: "2px, 2px"
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: "viewport"
                            }
                        }}
                    />
                </div>
                <OverlayTrigger placement="right" overlay={calendarTooltip}>
                    <div role="button" tabIndex="0" title="From date calendar button"
                            className= "Calendar-icon-from"  onClick={(e)=>fromCalendarOpenHandler(e)}
                            onKeyPress={(e)=>{ if (e.key === "Enter") fromCalendarOpenHandler(e)}} >
                    </div>
                </OverlayTrigger>                
                <div className="dateFromLabel">
                    <LabelText tid="Untill" />
                </div>
                <div className="datePickerUntilWidth">
                    <Datepicker
                        className={!props.isInValidUntilDate ? undefined : "highlight-date-field"}
                        tabIndex="0"
                        title="Until date calendar"
                        ref={untilRef}
                        dateFormat="dd/MM/yyyy" 
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={props.untilDate}
                        minDate={props.untilMinDate && parse(props.untilMinDate, "dd/MM/yyyy", new Date())}
                        maxDate={props.untilMaxDate && parse(props.untilMaxDate, "dd/MM/yyyy", new Date())}
                        onChange={date => props.untilDateChangeHandler(date)}
                        strictParsing={true} 
                        popperPlacement="right-end"
                        popperModifiers={{
                            offset: {
                                enabled: true,
                                offset: "2px, 2px"
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: "viewport"
                            }
                        }}
                    />
                </div>   
                <OverlayTrigger placement="right" overlay={calendarTooltip}>
                    <div id="until_calIcon" title="Until date calendar button"
                        role="button" tabIndex="0" className= "Calendar-icon-until"  onClick={(e)=>untilCalendarOpenHandler(e)}
                        onKeyPress={(e)=>{ if (e.key === "Enter") untilCalendarOpenHandler(e)}}/>
                </OverlayTrigger>  
            </Col>
    );
}


